import { createContext } from 'react';
import type { theme } from '@frameio/vapor-theme';

/**
 * Type definition for the toggle context value.
 */
export type ToggleButtonContextValue = {
  /**
   * Indicates whether the component is in toggle mode.
   */
  isToggle: boolean;

  /**
   * Enables ripple effect animation on interaction.
   */
  isRipple?: boolean;

  /**
   * Color key from theme to use when the toggle is selected.
   */
  selectedColor?: keyof typeof theme.colors.meta.opaque;
};

/**
 * Context to manage toggle-related state.
 */
export const ToggleContext = createContext<ToggleButtonContextValue>({
  isToggle: false,
  isRipple: false,
  selectedColor: undefined,
});
